import { writable, get } from 'svelte/store'
import { getGameDeck } from '../components/setCards'
import { clearStores } from './cardPLay.js'

const discardPile = []
let gameDeck = getGameDeck()
let playerHands = dealNineDown()

const deck = writable(gameDeck)
const hands = writable(playerHands)
const discard = writable(discardPile)
const gameScore = writable({
  playerHand: 0,
  computerHand: 0,
  gamePlayer: 0,
  gameComputer: 0,
})

const player = writable(playerHands[0])
const computer = writable(playerHands[1])

const currentPlayer = writable(0)

clearStores()
computerFirstHandSetUp()

function saveUnfinishedGame() {
  const game = {
    deck: deck,
    hands: hands,
    discard: discard,
    gameScore: gameScore,
    player: player,
    computer: computer,
    currentPlayer: currentPlayer
  }
  window.localStorage.setItem(name, JSON.stringify(game))
}

function loadUnfinishedGame(){
  const game = JSON.parse(localStorage.getItem('game'))
  if(game){
    const _deck = game.deck
    deck.set(_deck)
    const _hands = game.hands
    hands.set(_hands)
    const _discard = game.discard
    discard.set(_discard)
    const _gameScore = game.gameScore
    discard.set(_gameScore)
    const _player = game.player
    player.set(_player)
    const _computer = game.computer
    computer.set(_computer)
    const _currentPlayer = game.currentPlayer
    currentPlayer.set(_currentPlayer)
    return true
  }
}

function isPlayer() {
  let value = false
  const unsubscribe = currentPlayer.subscribe(val => {
    if (val === 0) value = true
  })
  unsubscribe()
  return value
}

function topDiscard() {
  let card
  const unsubscribe = discard.subscribe(cards => {
    card = cards[0]
  })
  unsubscribe()
  return card
}

function topDeck() {
  let card
  const unsubscribe = deck.subscribe(cards => {
    card = cards[0]
  })
  unsubscribe()
  return card
}

function revealDeckCard() {
  deck.update(cards => {
    cards[0].displayClass = 'visible'
    return [...cards]
  })
}

function startNextHand() {
  gameDeck = getGameDeck()
  playerHands = dealNineDown()
  deck.set(gameDeck)
  discard.set(discardPile)
  gameScore.set({
    playerHand: 0,
    computerHand: 0,
  })
  player.set(playerHands[0])
  computer.set(playerHands[1])
  currentPlayer.set(0)
  computerFirstHandSetUp()
}

function restartGame() {
  gameDeck = getGameDeck()
  playerHands = dealNineDown()
  deck.set(gameDeck)
  discard.set(discardPile)
  gameScore.set({
    playerHand: 0,
    computerHand: 0,
    gamePlayer: 0,
    gameComputer: 0,
  })
  player.set(playerHands[0])
  computer.set(playerHands[1])
  currentPlayer.set(0)
  computerFirstHandSetUp()
}

function updateGameScore(scores) {
  gameScore.set(scores)
}

function updatePlayer(playerNumber) {
  // currentPlayer.set(playerNumber)
  currentPlayer.update(value => {
    value = playerNumber
    return value
  })
}

function updateComputerHand(index, card) {
  card.displayClass = 'visible'
  card.handIndex = index
  computer.update(computerHandValue => {
    computerHandValue[index] = card
    return [...computerHandValue]
  })
}

function updatePlayerHand(index, card) {
  card.displayClass = 'visible'
  card.handIndex = index
  player.update(playerHandValue => {
    playerHandValue[index] = card
    return [...playerHandValue]
  })
}
/* 
function updateHand(handNumber, index, card) {
  hands.update(handValue => {
    card.displayClass = 'visible'
    handValue[handNumber][index] = card
    return [...handValue]
  })
}
 */
function replaceHand(handNumber, replacement) {
  if (handNumber === 0) {
    player.set(replacement)
  } else {
    computer.set(replacement)
  }
}

function addToDiscard(card) {
  discard.update(discardValue => {
    card.zoom = false
    card.handIndex = -1
    return [card, ...discardValue]
  })
}

function addArrayToDiscard(cardArray) {
  discard.update(discardValue => {
    for (let card of cardArray) {
      card.zoom = false
      card.handIndex = -1
    }
    return [...discardValue, cardArray]
  })
}

function removeFromDeck() {
  deck.update(deckValue => {
    return deckValue.slice(1)
  })
}

function removeFromDiscard() {
  discard.update(discardValue => {
    return discardValue.slice(0, -1)
  })
}

function computerFirstHandSetUp() {
  const card1 = getRandomInt(9)
  let card2 = getRandomInt(9)
  while (card1 === card2) {
    card2 = getRandomInt(9)
  }

  computer.update(handValue => {
    handValue[card1].displayClass = 'visible'
    return [...handValue]
  })

  computer.update(handValue => {
    handValue[card2].displayClass = 'visible'
    return [...handValue]
  })
}

function getRandomInt(max) {
  return Math.floor(Math.random() * Math.floor(max))
}

function dealNineDown() {
  const players = 2
  let card
  const hands = Array.from({ length: players }, () =>
    Array.from({ length: 9 }, () => card)
  )
  for (let i = 0; i < 9; i++) {
    for (let j = 0; j < players; j++) {
      hands[j][i] = gameDeck.pop()
      hands[j][i].displayClass = 'hidden'
      hands[j][i].handIndex = i
    }
  }
  discardPile.push(gameDeck.pop())
  discardPile[0].displayClass = 'visible'
  return hands
}

export {
  deck,
  hands,
  discard,
  player,
  computer,
  gameScore,
  isPlayer,
  updatePlayerHand,
  updateComputerHand,
  replaceHand,
  addToDiscard,
  topDiscard,
  topDeck,
  updatePlayer,
  currentPlayer,
  restartGame,
  removeFromDeck,
  removeFromDiscard,
  addArrayToDiscard,
  startNextHand,
  updateGameScore,
  revealDeckCard,
  saveUnfinishedGame,
  loadUnfinishedGame,
}
